import React from 'react';
import './Footer.scss';

import { Link } from 'react-router-dom';
const Footer = () => {
    return (
        <div className='footer-container' id="footer">
      <section className='footer-subscription'>
        <p className='footer-subscription-heading'>
        聯絡窗口
        </p>
        <p className='footer-subscription-text'>
        歡迎聯絡商業合作！
        </p>
        <div className='input-areas'>
          <form>
            <input
              className='footer-input'
              name='email'
              type='email'
              placeholder='你的信箱'
            />
            <button className='btn--outline'>訂閱</button>
          </form>
        </div>
      </section>
      <div className='footer-links'>
        <div className='footer-link-wrapper'>
          <div className='footer-link-items'>
            <h2>宇宙波波</h2>
            <Link to='/'>舒曼健康事業有限公司</Link>
            <Link to='/'>製造廠商：</Link>
            <Link to='/'>浩城科技有限公司</Link>
            <Link to='/'>(三重廠)</Link>
          </div>
          <div className='footer-link-items'>
            <h2>許可證字號</h2>
            <Link to='/'>新北府衛藥販字<br/>第623106L935號 </Link>
            <Link to='/'>新北府重衛藥製字<br/>第6131022203號</Link>
            <Link to='/'>衛部醫器製醫字<br/>第009240號</Link>
          </div>
        </div>
        <div className='footer-link-wrapper'>
          <div className='footer-link-items'>
            <h2>聯絡我們</h2>
            <Link to='/'>Instagram</Link>
            <Link to='/'>Facebook</Link>
            <Link to='/'>Youtube</Link>
            <Link to='/'>Twitter</Link>
          </div>
        </div>
      </div>
      <section className='social-media'>
        <div className='social-media-wrap'>
          <div className='footer-logo'>
            <Link to='/' className='social-logo'>
            宇宙波波우주보보
              
            </Link>
          </div>
          <small className='website-rights'>SamKo © 2021</small>
          <div className='social-icons'>
            <Link
              className='social-icon-link facebook'
              to='/'
              target='_blank'
              aria-label='Facebook'
            >
              <i className='fab fa-facebook-f' />
            </Link>
            <Link
              className='social-icon-link instagram'
              to='/'
              target='_blank'
              aria-label='Instagram'
            >
              <i className='fab fa-instagram' />
            </Link>
            <Link
              className='social-icon-link youtube'
              to='/'
              target='_blank'
              aria-label='Youtube'
            >
              <i className='fab fa-youtube' />
            </Link>
            <Link
              className='social-icon-link twitter'
              to='/'
              target='_blank'
              aria-label='Twitter'
            >
              <i className='fab fa-twitter' />
            </Link>
            <Link
              className='social-icon-link twitter'
              to='/'
              target='_blank'
              aria-label='LinkedIn'
            >
              <i className='fab fa-linkedin' />
            </Link>
          </div>
        </div>
      </section>
    </div>
    )
}

export default Footer
